export type MenuConfigList = Record<
  | 'asisten-guru'
  | 'asisten-guru-pm'
  | 'bukti-karya'
  | 'default'
  | 'forms'
  | 'pengajar-praktik'
  | 'penilaian-bukti-karya'
  | 'penilaian-kinerja'
  | 'penilaian-kinerja-dasus'
  | 'presensi'
  | 'timespend'
  | 'umpan-balik'
  | 'webinar',
  MenuConfigFn
>

export type MenuConfigFn = (param: MenuConfig) => {
  launchUrl: string
  title: string
  description: string
  privacyLevel: string
  courseNavigation: {
    url: string
    text: string
    enabled: boolean
    visibility: string //'public' | 'members' | 'admins'
  }
}

export type MenuConfig = {
  title?: string
  description?: string
  privacyLevel?: string
  courseNavigationText?: string
  courseNavigationVisibility?: string
  id?: string
}

export const menuConfig: MenuConfigList = {
  default: (param: MenuConfig) => {
    const {
      title = 'LTI Module',
      description = 'Integrate with Canvas FE service',
      privacyLevel = 'public',
      courseNavigationText = 'LTI Module',
      courseNavigationVisibility = 'public',
    } = param
    return {
      launchUrl: '',
      title,
      description,
      privacyLevel,
      courseNavigation: {
        url: '/api/launch',
        text: courseNavigationText,
        enabled: true,
        visibility: courseNavigationVisibility,
      },
    }
  },
  forms: (param: MenuConfig) => {
    const {
      id,
      title = 'LTI Form',
      description = 'Integrate with Canvas FE service',
      privacyLevel = 'public',
      courseNavigationText = 'LTI Form',
      courseNavigationVisibility = 'public',
    } = param
    return {
      launchUrl: `/api/launch/forms/${id}`,
      title,
      description,
      privacyLevel,
      courseNavigation: {
        url: `/api/launch/forms/${id}`,
        text: courseNavigationText,
        enabled: true,
        visibility: courseNavigationVisibility,
      },
    }
  },
  'pengajar-praktik': (param: MenuConfig) => {
    const {
      title = 'LTI Asisten',
      description = 'Pengisian jurnal murid oleh asisten',
      privacyLevel = 'public',
      courseNavigationText = 'LTI Asisten',
      courseNavigationVisibility = 'public',
    } = param
    return {
      launchUrl: `/api/launch/pengajar-praktik`,
      title,
      description,
      privacyLevel,
      courseNavigation: {
        url: `/api/launch/pengajar-praktik`,
        text: courseNavigationText,
        enabled: true,
        visibility: courseNavigationVisibility,
      },
    }
  },
  webinar: (param: MenuConfig) => {
    const {
      title = 'LTI Webinar',
      courseNavigationText = 'LTI Webinar',
      description = 'Daftar webinar',
      privacyLevel = 'public',
      courseNavigationVisibility = 'public',
    } = param
    return {
      launchUrl: `/api/launch/webinar`,
      title,
      description,
      privacyLevel,
      courseNavigation: {
        url: `/api/launch/webinar`,
        text: courseNavigationText,
        enabled: true,
        visibility: courseNavigationVisibility,
      },
    }
  },
  timespend: (param: MenuConfig) => {
    const {
      title = 'LTI Timespend',
      description = 'Manajemen timespend',
      privacyLevel = 'public',
      courseNavigationText = 'LTI Timespend',
      courseNavigationVisibility = 'admins',
    } = param
    return {
      launchUrl: `/api/launch/timespends`,
      title,
      description,
      privacyLevel,
      courseNavigation: {
        url: `/api/launch/timespends`,
        text: courseNavigationText,
        enabled: true,
        visibility: courseNavigationVisibility,
      },
    }
  },
  'penilaian-kinerja': (param: MenuConfig) => {
    const {
      title = 'LTI Penilaian Kinerja',
      description = 'Pengisian penilaian kinerja',
      privacyLevel = 'public',
      courseNavigationText = 'LTI Penilaian Kinerja',
      courseNavigationVisibility = 'public',
    } = param
    return {
      launchUrl: `/api/launch/penilaian-kinerja`,
      title,
      description,
      privacyLevel,
      courseNavigation: {
        url: `/api/launch/penilaian-kinerja`,
        text: courseNavigationText,
        enabled: true,
        visibility: courseNavigationVisibility,
      },
    }
  },
  presensi: (param: MenuConfig) => {
    const {
      title = 'LTI Presensi',
      description = 'Pengisian presensi peserta',
      privacyLevel = 'public',
      courseNavigationText = 'LTI Presensi',
      courseNavigationVisibility = 'public',
    } = param
    return {
      launchUrl: `/api/launch/presensi`,
      title,
      description,
      privacyLevel,
      courseNavigation: {
        url: `/api/launch/presensi`,
        text: courseNavigationText,
        enabled: true,
        visibility: courseNavigationVisibility,
      },
    }
  },
  'umpan-balik': (param: MenuConfig) => {
    const {
      title = 'LTI Umpan Balik',
      description = 'Umpan balik dari peserta',
      privacyLevel = 'public',
      courseNavigationText = 'LTI Umpan Balik',
      courseNavigationVisibility = 'public',
    } = param
    return {
      launchUrl: `/api/launch/umpan-balik`,
      title,
      description,
      privacyLevel,
      courseNavigation: {
        url: `/api/launch/umpan-balik`,
        text: courseNavigationText,
        enabled: true,
        visibility: courseNavigationVisibility,
      },
    }
  },
  'penilaian-kinerja-dasus': (param: MenuConfig) => {
    const {
      title = 'LTI Penilaian Kinerja Dasus',
      description = 'Pengisian penilaian kinerja Dasus',
      privacyLevel = 'public',
      courseNavigationText = 'LTI Penilaian Kinerja Dasus',
      courseNavigationVisibility = 'public',
    } = param
    return {
      launchUrl: `/api/launch/penilaian-kinerja-dasus`,
      title,
      description,
      privacyLevel,
      courseNavigation: {
        url: `/api/launch/penilaian-kinerja-dasus`,
        text: courseNavigationText,
        enabled: true,
        visibility: courseNavigationVisibility,
      },
    }
  },
  'bukti-karya': (param: MenuConfig) => {
    const {
      title = 'LTI Prasyarat Sertifikat',
      description = 'Pengisian Prasyarat Sertifikat',
      privacyLevel = 'public',
      courseNavigationText = 'LTI Prasyarat Sertifikat',
      courseNavigationVisibility = 'public',
    } = param
    return {
      launchUrl: `/api/launch/bukti-karya`,
      title,
      description,
      privacyLevel,
      courseNavigation: {
        url: `/api/launch/bukti-karya`,
        text: courseNavigationText,
        enabled: true,
        visibility: courseNavigationVisibility,
      },
    }
  },
  'penilaian-bukti-karya': (param: MenuConfig) => {
    const {
      title = 'LTI Validasi Prasyarat Sertifikat',
      description = 'Validasi Prasyarat Sertifikat',
      privacyLevel = 'public',
      courseNavigationText = 'LTI Validasi Prasyarat Sertifikat',
      courseNavigationVisibility = 'public',
    } = param
    return {
      launchUrl: `/api/launch/penilaian-bukti-karya`,
      title,
      description,
      privacyLevel,
      courseNavigation: {
        url: `/api/launch/penilaian-bukti-karya`,
        text: courseNavigationText,
        enabled: true,
        visibility: courseNavigationVisibility,
      },
    }
  },
  'asisten-guru': (param: MenuConfig) => {
    const {
      title = 'LTI Asisten Guru',
      description = 'Asisten Guru',
      privacyLevel = 'public',
      courseNavigationText = 'LTI Asisten Guru',
      courseNavigationVisibility = 'public',
    } = param
    return {
      launchUrl: `/api/launch/asisten-guru`,
      title,
      description,
      privacyLevel,
      courseNavigation: {
        url: `/api/launch/asisten-guru`,
        text: courseNavigationText,
        enabled: true,
        visibility: courseNavigationVisibility,
      },
    }
  },
  'asisten-guru-pm': (param: MenuConfig) => {
    const {
      title = 'LTI Asisten Guru (Pembelajaran Mendalam)',
      description = 'Asisten Guru (Pembelajaran Mendalam)',
      privacyLevel = 'public',
      courseNavigationText = 'LTI Asisten Guru (Pembelajaran Mendalam)',
      courseNavigationVisibility = 'public',
    } = param
    return {
      launchUrl: `/api/launch/asisten-guru-pm`,
      title,
      description,
      privacyLevel,
      courseNavigation: {
        url: `/api/launch/asisten-guru-pm`,
        text: courseNavigationText,
        enabled: true,
        visibility: courseNavigationVisibility,
      },
    }
  },
}
